module.exports = __webpack_public_path__ + "img/bildin-logo.c7d67fdb.svg";